import React from "react";

import { PDFImageProps } from "../../../../utils/models";
import { getChunkedData } from "../../../../utils/utilities";

import Conditional from "../../../common/conditional";
import CustomSection from "../custom-section";
import PDFPhotoPage from "../../../themed/pdf/pdfPhotoPage";

interface CustomGeneralPhotosProps {
    label: string;
    subLabel?: string;
    identifier?: string;
    photos: PDFImageProps[];
}
const CustomGeneralPhotos: React.FC<CustomGeneralPhotosProps> = ({ photos, label, subLabel, identifier }) => {
    return ( 
        <Conditional isVisible={photos.length > 0}>
            {getChunkedData(photos, 4).map((photoChunk, index) => (
                <CustomSection key={index} sectionTitle={label} sectionSubtitle={subLabel} identifier={identifier}>
                    <PDFPhotoPage photos={photoChunk} />
                </CustomSection>
            ))}
        </Conditional>
     );
}
 
export default CustomGeneralPhotos;